import React, { useState, useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { FiChevronDown, FiHelpCircle } from 'react-icons/fi';
import './FAQPage.css';

const FAQPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const pageRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    const ctx = gsap.context(() => {
      gsap.fromTo('.faq-header-content',
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }
      );
      gsap.fromTo('.faq-item',
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.5, stagger: 0.1, ease: 'power2.out', delay: 0.3 }
      );
    }, pageRef);
    return () => ctx.revert();
  }, []);

  const faqs = [
    {
      question: "What are your hospital's visiting hours?",
      answer: "Our general visiting hours are from 4:00 PM to 7:00 PM daily. However, visiting hours may vary for specific departments like the ICU. We recommend checking with the front desk for specific unit policies."
    },
    {
      question: "Do you accept health insurance?",
      answer: "Yes, we are empaneled with over 30 leading health insurance providers and offer cashless hospitalization facilities. Please visit our Insurance page or contact our TPA desk to verify your specific coverage."
    },
    {
      question: "How do I book an appointment?",
      answer: "You can book an appointment directly through this website by visiting the 'Book Appointment' page, calling our reception, or visiting the hospital in person."
    },
    {
      question: "Is emergency care available 24/7?",
      answer: "Yes, our Emergency and Trauma Care unit operates 24 hours a day, 7 days a week, staffed with specialists and equipped with advanced life-saving technology."
    },
    {
      question: "What should I bring for my first consultation?",
      answer: "Please bring any previous medical records, current prescriptions, a valid ID proof, and your insurance card if applicable."
    },
    {
      question: "Do you have in-house pharmacy and diagnostic services?",
      answer: "Yes, Swarup Hospital features a 24/7 in-house pharmacy and a fully equipped pathology lab and imaging center for your convenience."
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-page" ref={pageRef}>
      <header className="faq-header">
        <div className="faq-header-content">
          <FiHelpCircle className="faq-header-icon" />
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to common questions about our services, facilities, and patient care.</p>
        </div>
      </header>

      <section className="faq-content-section">
        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
              onClick={() => toggleAccordion(index)}
            >
              <div className="faq-question">
                <h3>{faq.question}</h3>
                <FiChevronDown className={`faq-icon ${activeIndex === index ? 'rotate' : ''}`} />
              </div>
              <div 
                className="faq-answer-wrapper" 
                style={{ 
                  maxHeight: activeIndex === index ? '200px' : '0px',
                  opacity: activeIndex === index ? 1 : 0
                }}
              >
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="faq-contact-box">
          <h3>Still have questions?</h3>
          <p>If you cannot find the answer to your question, please feel free to contact our support team.</p>
          <a href="/contact" className="btn btn-primary">Contact Us</a>
        </div>
      </section>
    </div>
  );
};

export default FAQPage;
